import { getCookie, hasCookie } from "cookies-next";

export const useFanduelTheme = (): boolean => {
  if (process.env.NODE_ENV === "test-native" || !hasCookie("useURP")) {
    return false;
  }

  const isFanduelTheme = getCookie("useURP");

  return isFanduelTheme === "true";
};
